import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase";
import storage from "./assets/js/Global";

const vapidKey = process.env.REACT_APP_VAPI_ID_KEY;

export const FCM_TOKEN_KEY = "fcm_token";

export const getStoredFcmToken = () => storage.get(FCM_TOKEN_KEY) || null;

export const requestForToken = async () => {
    try {
        const cached = getStoredFcmToken();
        if (cached) return cached;

        const permission = await Notification.requestPermission();
        console.log("Notification permission:", permission);

        if (permission !== "granted") {
            console.log("Notification permission denied");
            return null;
        }

        const currentToken = await getToken(messaging, {
            vapidKey,
        });

        if (currentToken) {
            storage.set(FCM_TOKEN_KEY, currentToken);
            return currentToken;
        } else {
            console.log("No registration token available");
            return null;
        }
    } catch (error) {
        console.log("Error getting token:", error);
        return null;
    }
};

export const onForegroundMessage = (cb) => onMessage(messaging, cb);